export const IMAGE_VISIBILITY_CONTAINER = '.js-images-visibility-container';
export const IMAGE_VISIBILITY_ITEM = '.js-images-visibility-item';
